export const staleTimeInMinutes = 15;

export const siteFleetType = {
  vduElectric: 'vduElectric',
  vduGas: 'vduGas',
  vduMixed: 'vduMixed',
  ft2Electric: 'ft2Electric',
  ft2Gas: 'ft2Gas',
  ft2Mixed: 'ft2Mixed',
  mixed: 'mixed'
}

export const ftPlusFleetTypes = [
  siteFleetType.ft2Electric,
  siteFleetType.ft2Gas,
  siteFleetType.ft2Mixed,
  siteFleetType.mixed,
];

export const userRoles = {
  admin: 1,
  accountManager: 2,
  support: 3,
  masterUser: 4,
  advancedUser: 5,
  basicUser: 6,
  service: 7
}

export const holeLocation = {
  unknown: 0,
  betweenHoles: 1,
  tee: 2,
  fairway: 3,
  green: 4
};

export const carType = {
  select: 0,
  normal: 1,
  marshal: 2,
  handicap: 3,
  bevcart: 4,
  outOfService: 5,
  member: 6,
  notInUse: 7,
  notCommunicating: 8,
  memberSpecial: 9,
};

export const guardianMode = {
  normal: 1,
  staging: 2,
  lockdown: 3
};

export const memberCarTrackingLevel = {
  Never: 0,
  Always: 1,
  InsideGeoFence: 2,
  OnCourseOrPlayingGolf: 3
};

export const speakerVolume = {
  UseFleetSetting: 0,
  External: 1,
  Internal: 2,
  ExternalAmp: 3,
};

export const fleetViewMode = {
  SmallList: 0,
  GridList: 1,
  TableList: 2,
};

export const isFtPlusSite = (fleetType) => ftPlusFleetTypes.includes(fleetType);

export const canManageAzLimits = (role) =>
  isUserAdmin(role) || isUserSupport(role) || isUserMaster(role);

export const actionZoneLimits = {
  MAX_VERTICES: 140,
  VERTEX_WARNING_THRESHOLD: 135,
  MAX_ACTION_ZONES: 200,
  ZONE_WARNING_THRESHOLD: 195,
};

// JG Note: I'm guessing these come from the UlLocationReportReason enum in Uplink.Shared.Core
export const REASON_FOR_REPORT_NEW_HOLE_STR = "NEW_HOLE";
export const REASON_FOR_REPORT_STOPPED_STR = "STOPPED";
export const REASON_FOR_REPORT_MOVING_STR = "MOVING";
export const REASON_FOR_REPORT_VCC_FADE_STR = "VCC_FADE";
export const REASON_FOR_REPORT_APN_FADE_STR = "APN_FADE";
export const REASON_FOR_REPORT_FORCED_STR = "FORCED";
export const REASON_FOR_REPORT_BLIND_SHOT_STR = "BLIND_SHOT";
export const REASON_FOR_REPORT_ACTION_ZONE_STR = "ACTION_ZONE";
export const REASON_FOR_REPORT_ACTION_ZONE_EXIT_STR = "ACTION_ZONE_EXIT";
export const REASON_FOR_REPORT_SOC_CHANGE_STR = "SOC_UPDATE";
export const REASON_FOR_REPORT_CAR_RESET_STR = "CAR_RESET";

// SCA FT
export const REASON_FOR_FT_REPORT_SPEED_ABOVE_25_STR = "SPEED_ABOVE_25";
export const REASON_FOR_FT_REPORT_SPEED_BELOW_25_STR = "SPEED_BELOW_25";
export const REASON_FOR_FT_REPORT_TIME_DISTANCE_STR = "TIME_DISTANCE";
export const REASON_FOR_FT_REPORT_GEOZONE_ENTRY_STR = "GEOZONE_ENTRY";
export const REASON_FOR_FT_REPORT_GEOZONE_EXIT_STR = "GEOZONE_EXIT";
export const REASON_FOR_FT_REPORT_ACKED_REPORT_STR = "ACKED_REPORT";

export const reportReasons = {
  REASON_FOR_REPORT_UNDEFINED: -999,
  REASON_FOR_REPORT_NEW_HOLE: 1,
  REASON_FOR_REPORT_STOPPED: 2,
  REASON_FOR_REPORT_MOVING: 3,
  REASON_FOR_REPORT_VCC_FADE: 4,
  REASON_FOR_REPORT_APN_FADE: 5,
  REASON_FOR_REPORT_FORCED: 6,
  REASON_FOR_REPORT_BLIND_SHOT: 7,
  REASON_FOR_REPORT_ACTION_ZONE: 8,
  REASON_FOR_REPORT_ACTION_ZONE_EXIT: 9,
  REASON_FOR_REPORT_SOC_CHANGE: 10,
  REASON_FOR_REPORT_CAR_RESET: 11,

  // SCA FT
  REASON_FOR_FT_REPORT_SPEED_ABOVE_25: 21,
  REASON_FOR_FT_REPORT_SPEED_BELOW_25: 22,
  REASON_FOR_FT_REPORT_TIME_DISTANCE: 23,
  REASON_FOR_FT_REPORT_GEOZONE_ENTRY: 24,
  REASON_FOR_FT_REPORT_GEOZONE_EXIT: 25,
  REASON_FOR_FT_REPORT_ACKED_REPORT: 26,
};

export const PACE_STATUS_UNDEFINED = -999;
export const PACE_STATUS_NORMAL = 1;
export const PACE_STATUS_WARNING = 2;
export const PACE_STATUS_CRITICAL = 3;

export const PACE_STATUS_NORMAL_STR = "Normal";
export const PACE_STATUS_WARNING_STR = "Warning";
export const PACE_STATUS_CRITICAL_STR = "Critical";

export const getFeatureSetOption = (list, option1, option2) => {
  if (option1 && option2) {
    return list?.indexOf(option1) >= 0 && list?.indexOf(option2) >= 0
      ? false
      : true;
  } else {
    return list?.indexOf(option1) >= 0 ? false : true;
  }
};

export const getFeaturesList = () => {
  return {
    car_control: "C",
    real_time_tracking: "T",
    golfer_experience: "G",
    tournament_scoring: "E",
    flyovers: "V",
    adman_pro: "A",
    adman_event: "S",
    commercial: "R",
    bluetooth: "B",
    member_cars: "D",
    service: "H",
    survey: "Q",
  };
};

export function isUserAdmin(role) {
  return role === 1;
}

export function isUserReadOnly(role) {
  return role === 0;
}
export function isUserMaster(role) {
  return role === 8;
}

export function isUserBasic(role) {
  return role === 32;
}
export function isUserSupport(role) {
  return role === 4;
}

export const userPrivileges = {
  TiersAdmin: 1,
  SiteSetup: 2,
  ClickToDrive: 3,
  SWAssignment: 4,
  CanDig: 5,
  VehicleStatus: 6,
  SWCreation: 7,
  AllSitesView: 8,
  SharedImages: 9,
  AdminCode: 10,
  LastRTWiFI: 11
};
export const chargeControlMode =
{
  Normal: 0, // car can charge normally
  Inhibited: 1, // charging inhibited due to OPC (Outside OPC charging times)
  Opportunity: 2 //	Outside OPC times but allowed to charge due to opportunity charging
}
export const FOUND_MARKER_Z_INDEX = 140;
export const CRTICAL_MARKER_Z_INDEX = 120;
export const WARNING_MARKER_Z_INDEX = 110;
export const NORMAL_MARKER_Z_INDEX = 100;
export const GUIDE_HALO_AZ_Z_INDEX = 90;
export const SELECTED_POLYGON_Z_INDEX = 80;
export const NORMAL_POLYGON_Z_INDEX = 70;
export const BACKGROUND_POLYGON_Z_INDEX = 60;
export const HOVER_CAR_HISTORY_Z_INDEX = 30;
export const NORMAL_CAR_HISTORY_Z_INDEX = 20;
export const HOLE_MARKER_Z_INDEX = 10;
export const TEE_MARKER_Z_INDEX = 5;
export const MARKER_Z_INDEX_DELTA = 100;

export function reasonForReportString(x) {
  if (x === reportReasons.REASON_FOR_REPORT_NEW_HOLE || x === REASON_FOR_REPORT_NEW_HOLE_STR)
    return "New hole/loc";
  else if (
    x === reportReasons.REASON_FOR_REPORT_STOPPED ||
    x === REASON_FOR_REPORT_STOPPED_STR
  )
    return "Stopped";
  else if (x === reportReasons.REASON_FOR_REPORT_MOVING || x === REASON_FOR_REPORT_MOVING_STR)
    return "Moving";
  else if (
    x === reportReasons.REASON_FOR_REPORT_VCC_FADE ||
    x === REASON_FOR_REPORT_VCC_FADE_STR
  )
    return "Vcc Fade";
  else if (
    x === reportReasons.REASON_FOR_REPORT_APN_FADE ||
    x === REASON_FOR_REPORT_APN_FADE_STR
  )
    return "Apn Fade";
  else if (x === reportReasons.REASON_FOR_REPORT_FORCED || x === REASON_FOR_REPORT_FORCED_STR)
    return "Forced";
  else if (
    x === reportReasons.REASON_FOR_REPORT_BLIND_SHOT ||
    x === REASON_FOR_REPORT_BLIND_SHOT_STR
  )
    return "Blind Shot";
  else if (
    x === reportReasons.REASON_FOR_REPORT_ACTION_ZONE ||
    x === REASON_FOR_REPORT_ACTION_ZONE_STR
  )
    return "Action Zone";
  else if (
    x === reportReasons.REASON_FOR_REPORT_ACTION_ZONE_EXIT ||
    x === REASON_FOR_REPORT_ACTION_ZONE_EXIT_STR
  )
    return "Action Zone exit";
  else if (
    x === reportReasons.REASON_FOR_REPORT_SOC_CHANGE ||
    x === REASON_FOR_REPORT_SOC_CHANGE_STR
  )
    return "SOC update";
  else if (
    x === reportReasons.REASON_FOR_REPORT_CAR_RESET ||
    x === REASON_FOR_REPORT_CAR_RESET_STR
  )
    return "Car Reset";
  // SCA FT
  else if (
    x === reportReasons.REASON_FOR_FT_REPORT_SPEED_ABOVE_25 ||
    x === REASON_FOR_FT_REPORT_SPEED_ABOVE_25_STR
  )
    return "Speed Above 25 m.p.h.";
  else if (
    x === reportReasons.REASON_FOR_FT_REPORT_SPEED_BELOW_25 ||
    x === REASON_FOR_FT_REPORT_SPEED_BELOW_25_STR
  )
    return "Speed Below 25 m.p.h.";
  else if (
    x === reportReasons.REASON_FOR_FT_REPORT_TIME_DISTANCE ||
    x === REASON_FOR_FT_REPORT_TIME_DISTANCE_STR
  )
    return "Standard Report";
  else if (
    x === reportReasons.REASON_FOR_FT_REPORT_GEOZONE_ENTRY ||
    x === REASON_FOR_FT_REPORT_GEOZONE_ENTRY_STR
  )
    return "Geozone Entry";
  else if (
    x === reportReasons.REASON_FOR_FT_REPORT_GEOZONE_EXIT ||
    x === REASON_FOR_FT_REPORT_GEOZONE_EXIT_STR
  )
    return "Geozone Exit";
  else if (
    x === reportReasons.REASON_FOR_FT_REPORT_ACKED_REPORT ||
    x === REASON_FOR_FT_REPORT_ACKED_REPORT_STR
  )
    return "Acknowledged Report";
  else return "None";
}

export let holeAreaType = {
  Tee: 0,
  Fairway: 1,
  Green: 2,
  Extents: 3,
};

// utility function to convert a signed int to text/HEX RGB value
export function convIntToRGB(c) {
  let rgb = "ffffff";
  // convert the signed int to an unsigned int
  c = c >>> 0;
  // convert to HEX and get the last 6 chars for the RGB value
  if (c) rgb = c.toString(16).substr(-6);
  return rgb;
}

export const deviceType = {
  VDU: 0, // Tsunami VDU
  G2: 1, // G2
  VDU21: 2, // VDU 2.1
  FT: 3, // Fleet Tracker (e.g. Calamp)
  VDU3: 4, // VDU 3.0 (HW used with Android as OS)
  LT: 5,
  WT: 6, // Walker Tag
  FT2: 7, // FT+, aka ProDrive
  VDU4: 8, // VDU 3.0 (HW used with Android as OS)
};

export const productLevel = {
  VisageBasic: 0,
  VisageRT: 1,
  VisageRTPlus: 2,
  VisageTiered: 3,
  VisageSharkExp: 4,
};

export const controlType =
{
  None: 0,
  LIN: 1,
  Fusion: 2,
  GCCM: 3
};

export const distanceUnits = {
  Unknown: 0,
  Yards: 1,
  Metres: 2
};

export const featureKey = {
  //FYI-Description as in DB commented to right, its whats shown to user
  carControl: "C", // Car control
  tracking: "T", // Real-time tracking
  golf: "G", // Golfer experience
  events: "E", // Tournament scoring
  flyovers: "V", // Flyovers
  adManager: "A", // AdMan Pro
  eventAdManager: "S", // AdMan Event
  resortEdition: "R", // Commercial
  sharkExpB2B: "X", // Shark Experience BtoB
  sharkExpB2C: "Y", // Shark Experience BtoC
  power: "P", // Shark Power
  sharkExpB2BL: "W", // Shark Experience BtoB Light
  foodBevAddon: "F", // Shark B2C F&B
  bluetooth: "B", // Bluetooth (note, this desc is modified in code based on product)
  sharkTrial: "Z", // Shark Trial
  sharkUpgrade: "U", // Shark Upgrades
  sharkMonthly: "M", // Shark Monthly Billing
  memberCars: "D", // Member Cars
  surveys: "Q", // Survey
  service: "H", // Service
  SelectBT: "J", // Select BT
  SelectPlus: "K", // Select+
  SelectPlusPlus: "L", // Select++
};

export let actionZoneBufferWidth = [
  2, //1128.497220, Zoom Level 1
  2, //2256.994440,
  2, //4513.988880,
  2, //9027.977761,
  2, //18055.955520,
  2, //36111.911040,
  2, //72223.822090,
  2, //144447.644200,
  2, //288895.288400,
  2, //577790.576700,
  2, //1155581.153000,
  2, //2311162.307000,
  2, //4622324.614000,
  2, //9244649.227000,
  2, //18489298.450000,
  4, //36978596.910000,
  8, //73957193.820000,
  20, //147914387.600000,
  36, //295828775.300000,
  64 //591657550.500000  Zoom level 20
];

export let faultBit = {
  BldOverCurrent: 0x00000001,
  CurrentSenseFault: 0x00000002,
  FieldMissing: 0x00000004, //A if the speed controller is operating at 90% and the field current is less than 3 amps
  HighPedalDetect: 0x00000008, // (HPD) High Pedal Detect
  HwFailSafe: 0x00000010, //A failure in the armature drive field effect transistors (FET)
  IncorrectPassword: 0x00000020,
  LowBatteryVoltage: 0x00000040,
  MainCoilOpen: 0x00000080,
  MainDriverOff: 0x00000100, //A if the FET that closes the solenoid contacts is not energized when it should be
  MainDriverOn: 0x00000200, //A if the FET that closes the solenoid contacts is energized when it should not be
  MainDriverOverCurrent: 0x00000400,
  MainDrop1: 0x00000800,
  MainDrop2: 0x00001000,
  MaximumPasswordTries: 0x00002000,
  MotorStall: 0x00004000, // motor current is high and there is no movement of the wheels
  MainWelded: 0x00008000, //A if the solenoid contacts are welded closed
  MShorted: 0x00010000, //A
  OverVoltage: 0x00020000, // if the battery voltage is too high (68.4 to 75.6 volts DC)
  SpeedSensorFault: 0x00040000, //A if speed pulses are not detected with > 75% armature PWM
  ThermalCutback: 0x00080000, // if the battery voltage falls below 34 volts
  ThrottleFault: 0x00100000, // if the motor controller output regulator is < .2 or > 4.8 volts

  // New faults for LIN 2.0
  LockoutFault: 0x00200000,
  LowSOC: 0x00400000,
  HighSpeedWalkaway: 0x00800000,

  InoperableCharger: 0x01000000, // inoperable charge
};

export const mapSymbols = {
  DIAMOND: {
    path: "M -1,0 0,-1 1,0 0,1 z",
    strokeColor: "#FFFF00",
    fillColor: "#FFFF00",
    scale: 4,
    fillOpacity: .75
  }
}

export const newPolyFillColor = 'Magenta'; // so user can see new ones that haven't been saved yet
export const sizzleReelAZColor = "#00FFFF";

export const actionZoneTypes =
{
  Unknown: 0,
  CompleteStop: 1,
  StopAndReverse: 2,
  Alert2mph: 3,
  Caution7mph: 4,
  Caution10mph: 5,
  NoSpeedRestriction: 6,
  Limit3MPH: 7,
  Limit4MPH: 8,
  Limit5MPH: 9,
  Limit6MPH: 10,
  Limit8MPH: 11,
  Limit9MPH: 12
};

export const sizzleReelAZText = "VID:SIZZLE_REEL";

export const maximumMapZoomLevel = 20;

export const azEditingCursorCssClass = [
  'azEditCursorDefault', // Zoom Level 1
  'azEditCursorDefault',
  'azEditCursorDefault',
  'azEditCursorDefault',
  'azEditCursorDefault',
  'azEditCursorDefault',
  'azEditCursorDefault',
  'azEditCursorDefault',
  'azEditCursorDefault',
  'azEditCursorDefault',
  'azEditCursorDefault',
  'azEditCursorDefault',
  'azEditCursorDefault',
  'azEditCursorDefault',
  'azEditCursorDefault',
  'azEditCursorDefault',
  'azEditCursorDefault',
  'azEditZoomLevel18',
  'azEditZoomLevel19',
  'azEditZoomLevel19' // Not using zoom 20 because it was decided 19 works best for now
];

export const azCreateCursorCssClass = [
  'azEditCursorDefault', // Zoom Level 1
  'azEditCursorDefault',
  'azEditCursorDefault',
  'azEditCursorDefault',
  'azEditCursorDefault',
  'azEditCursorDefault',
  'azEditCursorDefault',
  'azEditCursorDefault',
  'azEditCursorDefault',
  'azEditCursorDefault',
  'azEditCursorDefault',
  'azEditCursorDefault',
  'azEditCursorDefault',
  'azEditCursorDefault',
  'azEditCursorDefault',
  'azEditCursorDefault',
  'azEditCursorDefault',
  'azCreateZoomLevel18',
  'azCreateZoomLevel19',
  'azCreateZoomLevel19'// Not using zoom 20 because it was decided 19 works best for now
];

export const siteSettingsTypes = {
  siteAreaType: 1,
  holeArea: 2,
  centerOfGreen: 3,
  teeMarkers: 4,
  pointOfInterest: 5
}

export const settingsPoITypes = {
  hole: 2,
  approach: 3
}

export const googleMapLibraries = ["drawing", "marker"];

export const holesConst = {
  select: -2,
  useFleetSetting: 0,
  nine: 9,
  eighteen: 18,
  unlimited: -1
}

export const speedLimitConst = {
  select: -2,
  default: 0 | -1
}

export const distances = {
  select: -1,
  hideDistances: 0,
  showDistances: 1,
  useFleetSetting: 2
}

export const connectionType = {
  wifi: 0,
  realtime: 1,
  none: 2,
}

export const carConnectionType = {
  notCommunicatingCarEnabled: 2,
}

export const batteryLevel = {
  warning: 25,
  critical: 10
}

export const voltageLevel = {
  warning: 12.2,
  critical: 12.0
}

export const paceStatus = {
  warning: 2,
  critical: 3
}